<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"Checkout" | translate}}</h5>
        <div class="edit-icons" mat-dialog-close="">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="row mt-3 mb-xl-2 item-content">

        <div [ngClass]="paymentData.price == 0 ? 'col-md-12':'col-md-6'" *ngIf="courseData">
            <div class="d-flex mb-3 mb-xl-2 flex-md-nowrap flex-wrap">
                <div class="c-img me-3" [appBackgroundImg]="courseData.img" iType="course" *ngIf="(itemType==1)">
                </div>
                <div class="c-img me-3" [appBackgroundImg]="courseData.img" iType="package" *ngIf="(itemType!=1)">
                </div>
                <div class="mt-2 mt-lg-3">
                    <h5>{{courseData.tit}} </h5>
                    <p class="steel-blue">{{ courseData.dep }} </p>
                    <div>
                        <img src="assets/images/package/price.png" class="img-fluid" /> <span class="ms-1 text-bold">
                            {{courseData.pr}}€</span>
                    </div>
                </div>
            </div>
            <div *ngIf="itemType==1 && !refferalCode">
                <label for="" class="">Voucher</label>
                <form [formGroup]="voucherForm">
                    <div class="d-flex align-items-center ">
                        <div class="flex-grow-1 me-3">
                            <input type="text" class="form-control voucher" formControlName="voucherCode">
                        </div>
                        <button mat-raised-button color="primary" class="auth-form-btn no-sh-btn" type="submit"
                            (click)="applyVoucher()">
                            Apply</button>
                    </div>
                </form>
            </div>

            <div>
                <mat-error
                    *ngIf="!isValidVoucher && voucherForm.get('voucherCode')?.touched && !isExpiredVoucher">Invalid
                    voucher code</mat-error>
                <mat-error *ngIf="isExpiredVoucher">Voucher code is expired</mat-error>
                <mat-error
                    *ngIf="voucherForm.get('voucherCode')?.hasError('required') && voucherForm.get('voucherCode')?.touched">Please
                    enter valid code</mat-error>
            </div>
            <div *ngIf="paymentData">
                <div class="d-flex justify-content-between item-cont mt-3 mt-lg-4">
                    <div class="i-l">Item Total</div>

                    <div class="text-bold">{{courseData.pr}}€</div>

                </div>
                <div class="d-flex justify-content-between item-cont">
                    <div class="i-l">Voucher Discount ({{paymentData.discount_percentage}}%) - </div>
                    <div class="text-bold">{{paymentData.discount_price}}€ </div>
                </div>
                <div class="d-flex justify-content-between item-cont">
                    <div class="i-l">VAT ({{paymentData.vat_percentage }} %) - </div>
                    <div class="text-bold"> {{ paymentData.vat }}€</div>
                </div>
                <div class="d-flex justify-content-between item-cont l-cont">
                    <div class="">Pay Now - </div>
                    <div class="text-bold primary-text">{{ paymentData.price | number }}€</div>
                </div>
            </div>
            <div class="d-box">
                <button mat-raised-button color="primary" class="auth-form-btn mt-5" type="submit"
                    *ngIf="paymentData.price == 0" (click)="onClickFreeCourse()"> Buy Free</button>
            </div>

        </div>
        <div class="" *ngIf="offerData" [ngClass]="isBuyFreeOfferPackage ? 'col-12':'col-md-6'">
            <div class="title mt-md-3 pb-md-2">
                Billed <span *ngIf="!isYearly"> Monthly</span> <span *ngIf="isYearly">Yearly</span>
            </div>
            <div>
                <div class="d-flex justify-content-between item-cont mt-3 mt-lg-4">
                    <div class="flex-wrap s-cont">
                        <div class="d-flex align-items-center ">
                            <div class="img-div">
                                <img src="assets/images/icons/oprations_ic.svg" height="20px" alt="">
                            </div>
                            <div class="i-l">Operations </div>
                        </div>
                        <div *ngIf="isOfferPackage">
                            <div class="flag purple mt-2 mb-2" *ngIf="dialogData.p_data.operation=='Small'">Small</div>
                            <div class="flag purple mt-2 mb-2" *ngIf="dialogData.p_data.operation=='Advanced'">Advanced</div>
                            <div class="flag green-l mt-2 mb-2" *ngIf="dialogData.p_data.operation=='Expert'">Expert </div>
                            <div class="flag pink mt-2 mb-2" *ngIf="dialogData.p_data.operation=='Basic'">Basic</div>
                        </div>

                    </div>
                    <div class="price">€{{ offerData.ope }} <span *ngIf="!isYearly">/mo </span> <span
                            *ngIf="isYearly">/mo*12 </span> </div>

                </div>
                <div class="d-flex justify-content-between item-cont ">
                    <div class="s-cont flex-wrap">
                        <div class="d-flex align-items-center ">
                            <div class="img-div"><img src="assets/images/icons/communications.svg" height="20px" alt="">
                            </div>
                            <div class="i-l">Communications </div>
                        </div>
                        <div *ngIf="isOfferPackage">
                            <div class="flag purple mt-2 mb-2" *ngIf="dialogData.p_data.communication=='Small'">Small</div>
                            <div class="flag purple mt-2 mb-2" *ngIf="dialogData.p_data.communication=='Advanced'">
                                Advanced</div>
                            <div class="flag green-l mt-2 mb-2" *ngIf="dialogData.p_data.communication=='Expert'">Expert
                            </div>
                            <div class="flag pink mt-2 mb-2" *ngIf="dialogData.p_data.communication=='Basic'">Basic
                            </div>
                        </div>
                    </div>
                    <div class="price">€{{ offerData.comm }}<span *ngIf="!isYearly">/mo </span> <span
                            *ngIf="isYearly">/mo*12 </span></div>
                </div>
                <div class="d-flex justify-content-between item-cont">
                    <div class="s-cont flex-wrap">
                        <div class="d-flex align-items-center ">
                            <div class="img-div"><img src="assets/images/icons/hr&skills.svg" alt=""></div>
                            <div class="i-l">HR & Skills </div>
                        </div>
                        <div *ngIf="isOfferPackage">
                            <div class="flag purple mt-2 mb-2" *ngIf="dialogData.p_data.hr=='Small'">Small</div>
                            <div class="flag purple mt-2 mb-2" *ngIf="dialogData.p_data.hr=='Advanced'">Advanced</div>
                            <div class="flag green-l mt-2 mb-2" *ngIf="dialogData.p_data.hr=='Expert'">Expert</div>
                            <div class="flag pink mt-2 mb-2" *ngIf="dialogData.p_data.hr=='Basic'">Basic</div>
                        </div>
                    </div>
                    <div class="price">€{{ offerData.hrsk }}<span *ngIf="!isYearly">/mo </span> <span
                            *ngIf="isYearly">/mo*12 </span></div>
                </div>
            </div>


            <div class=" item-cont" *ngIf="!isBuyFreeOfferPackage">
                <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="d-flex flex-wrap s-cont">
                        <div class="i-l me-2">15 Additional user seats </div>
                        <div class="  primary-color cursor-pointer" (click)="onAddUser()"> + Add</div>
                    </div>
                    <div class="price">€{{ offerData.e_u }}/mo <span  *ngIf="isYearly">*12</span> </div>
                </div>
            </div>

            <div class="user-box" *ngIf="isAddUser">
                <div class="icon">
                    <i class="material-icons close-icon me-auto " (click)="onAddUser()">close</i>
                </div>

                <div class="sel-t">Select the number of seats to be added to your plan</div>
                <div class="d-flex align-items-center flex-wrap flex-md-nowrap">
                    <input type="number" class="form-control me-3 mt-2" placeholder="Enter Number"
                        [(ngModel)]="perUser">
                    <button mat-raised-button color="primary" class="auth-form-btn mt-2" type="submit"
                        (click)="addSeat()"> Add Seats</button>
                </div>
                <div class="sel-t per mt-2">€{{ offerData.p_u }} per seat </div>
                <div>
                    <mat-error *ngIf="errorMsg">{{errorMsg}}</mat-error>
                </div>
            </div>
            <div class="d-flex justify-content-between item-cont l-cont">
                <div class="">Vat({{offerData.vat }} %) </div>
                <div class="price  " *ngIf="offerData.pl=='m'">€{{ offerData.vat_c | number }}/mo</div>
                <div class="price " *ngIf="offerData.pl=='y'">€{{ offerData.vat_c_12 | number }}
                </div>
            </div>

            <div class="d-flex justify-content-between item-cont l-cont">
                <div class="price">To Pay Now - </div>
                <div class="price primary-color l" *ngIf="offerData.pl=='m'">{{ offerData.tot_cal | number }}€</div>
                <div class="price primary-color l" *ngIf="offerData.pl=='y'">{{ offerData.tot_cal_12 | number }}€
                </div>
            </div>

            <div class="d-box" *ngIf="isBuyFreeOfferPackage">
                <button mat-raised-button color="primary" class="auth-form-btn mt-5" type="submit"
                     (click)="onBuyFreeOffer()"> Buy Free</button>
            </div>
        </div>

        <div class="col-md-6" [ngClass]="(paymentData &&paymentData.price == 0 || isBuyFreeOfferPackage )? 'd-none':''">
            <div class="p-box">
                <div class=" tab-box flex-wrap ">
                    <div class=" d-flex justify-content-center align-items-center mb-3 me-2 me-sm-3 tab-item" id="i-4"
                        (click)="onPaymentType('stripe')" [ngClass]="paymentType=='stripe' ? 'active-tab' :''">
                        <img src="assets/images/icons/credit_card_ic.svg" alt="">
                        <div class="tab-txt ps-1 ps-sm-2 ">Credit Card</div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center tab-item " id="i-1"
                        [ngClass]="paymentType=='paypal' ? 'active-tab' :''" (click)="onPaymentType('paypal')">
                        <div class="tab-txt ps-1 ps-sm-2 ">Paypal</div>
                    </div>
                </div>
                <div class="mt-3 flip-container" (click)="flipCard()" *ngIf="paymentType=='stripe'">
                    <div class="flipper" [class.flipped]="isFlipped">
                        <div class="front"><img src="assets/images/credit_card.svg" class="img-fluid" alt="">
                        </div>
                        <div class="back"><img src="assets/images/credit_card.svg" class="img-fluid" alt="">
                        </div>
                    </div>
                </div>
                <div ngxStripeCardGroup [formGroup]="stripeCard" [elementsOptions]="elementsOptions"
                    *ngIf="paymentType=='stripe'">
                    <label for="" class="mt-3 mt-lg-4">Card Holder Name</label>
                    <div class="d-flex align-items-center ">
                        <input type="text" class="form-control" formControlName="name"
                            placeholder="Enter card holder name">
                    </div>
                    <label for="" class="mt-3 mt-lg-4">Card Number</label>
                    <div class=" s-c">
                        <ngx-stripe-card-number [options]="cardOptionsNumber"></ngx-stripe-card-number>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label for="" class="mt-4 ">Expiry Date</label>
                            <div class=" s-c">
                                <ngx-stripe-card-expiry [options]="cardOptions"></ngx-stripe-card-expiry>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="" class="mt-4">CVV</label>
                            <div class=" s-c">
                                <ngx-stripe-card-cvc [options]="cardOptions"></ngx-stripe-card-cvc>
                            </div>
                        </div>
                    </div>
                    <mat-error *ngIf="error!=''">{{error}}</mat-error>
                    <div class="m-auto my-3 my-lg-4">
                        <button mat-raised-button color="primary" class="auth-form-btn  " type="submit"
                            (click)="createToken()"> Pay Now</button>
                    </div>
                </div>
                <mat-error *ngIf="isVoucherError">Please
                    enter valid voucher code</mat-error>
                <div *ngIf="paymentType=='paypal'" class="m-auto my-3 my-lg-4">
                    <button mat-raised-button color="primary" class="auth-form-btn " type="submit" (click)="onPayPal()">
                        Pay Now</button>
                </div>

            </div>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>